// @flow
import React from 'react';

import { Button } from 'primitive-components';

import GustoLogo from './GustoLogo';
import GustoPageLayout from './GustoPageLayout';

type GustoAccountCreateStatusProps = {
  buttonText: string,
  onClickButton: Function,
  descriptionText: string,
};

const GustoAccountCreateStatus = ({
  buttonText,
  onClickButton,
  descriptionText,
}: GustoAccountCreateStatusProps) => (
  <GustoPageLayout>
    <GustoLogo />
    <p data-test-id="description">{descriptionText}</p>
    <Button styleType="primary" onClick={onClickButton}>
      {buttonText}
    </Button>
  </GustoPageLayout>
);

export default GustoAccountCreateStatus;
